module.exports = __webpack_public_path__ + "img/categories-decor.fc61598.png";